export const validateOrdersData = (order) => {
	const errors = {};

	const toTrimmed = (v) => (typeof v === "string" ? v.trim() : "");

	// 1) Description: valid string with more than 1 character
	const description = toTrimmed(order?.desc ?? order?.description ?? "");
	if (description.length < 2) {
		errors.desc = "Description must be at least 2 characters.";
	}

	// 2) Quantity: valid number greater than 1
	const rawQty = order?.qty ?? order?.quantity;
	const qtyNum = typeof rawQty === "string" ? Number(rawQty) : rawQty;
	if (!(Number.isFinite(qtyNum) && qtyNum > 1)) {
		errors.qty = "Quantity must be a number greater than 1.";
	}

	// 3) Organization: must be selected and be a valid MongoDB ObjectId (24 hex chars)
	const organization = toTrimmed(
		order?.organization ?? order?.organizationId ?? order?.orgId ?? ""
	);
	const isMongoId = /^[a-fA-F0-9]{24}$/.test(organization);
	if (!isMongoId) {
		errors.organization = "Organization is required.";
	}

	return [Object.keys(errors).length === 0, errors];
}
